<script>
/**
 * 連携先からのコールバック先
 */
import freeeForm from './_freee.vue'

export default {
  name: "ProviderCallback",
  components: {
    freeeForm
  },
  mixins: [],
  props: {},
  data() {
    return {
      provider: null,
    }
  },
  computed: {},
  watch: {},
  created() {
    this.provider = this.$route.params.provider
  },
  methods: {},
}
</script>

<template>
  <v-container :fluid="true">
    <v-overlay>
      <v-progress-circular indeterminate size="64" width="6" color="primary" />
    </v-overlay>
    <freee-form v-if="provider === 'freee'" :provider="provider" />
  </v-container>
</template>
